import configuration from '../../utilities/configuration';
import { BaseModel } from "sjs-base-model";
import PublicLinkModel from "../../models/publicLink/PublicLinkModel";
import * as EffectUtility from "../../utilities/EffectUtility";

export async function requestPublicLinks(orderId) {
    const endpoint = configuration.apiServer + configuration.apiPublicLinkPath + "/" + orderId;
    return EffectUtility.getToModel(PublicLinkModel, endpoint);
}

export async function addPublicLink(orderId, days) {
    const endpoint = configuration.apiServer + configuration.apiPublicLinkPath + "/" + orderId;
    return EffectUtility.postToModel(BaseModel, endpoint, days);
}

export async function deletePublicLink(publicLinkId) {
    const endpoint = configuration.apiServer + configuration.apiPublicLinkPath + "/" + publicLinkId;
    return EffectUtility.deleteToModel(BaseModel, endpoint);
}
